export const ACCOUNT_CREATE = 'rent-web-account-create';
export const ACCOUNT_CREATE_STARTED = 'rent-web-account-create-started';
export const SUBSCRIBER_GATE = 'rent-web-subscriber-gate';
export const ACCOUNT_CREATE_WEB_VIEW = 'rent-ios-webview';
